import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userAuth: {
    user: null,
  },
  resetToken: null,
};

export const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    callAuth: (state, { payload }) => {
      return {
        ...state,
        userAuth: payload,
      };
    },
    clearUser: (state, { payload }) => {
      return {
        ...state,
        userAuth: {
          user: null,
        },
      };
    },
    setResetToken: (state, { payload }) => {
      return {
        ...state,
        resetToken: payload,
      };
    },
  },
});

export const { callAuth, clearUser, setResetToken } = AuthSlice.actions;

export default AuthSlice.reducer;
